import { z } from "zod";

import { fetchOneBuilderEntry } from "@/libs/builder/tools/fetchOneBuilderEntry";

export type SavLiveChatConfig = z.infer<typeof SAV_LIVECHAT_CONFIG_SCHEMA>;

const SAV_LIVECHAT_CONFIG_SCHEMA = z.boolean();

const savLiveChatConfig = (data: unknown): data is SavLiveChatConfig => {
  return SAV_LIVECHAT_CONFIG_SCHEMA.safeParse(data).success;
};

export const getSavLiveChatConfig = async ({
  locale,
}: {
  locale: string;
}): Promise<SavLiveChatConfig> => {
  const content = await fetchOneBuilderEntry({
    model: "soft-age-verification-live-chat-ca-config",
    locale,
  });

  if (savLiveChatConfig(content?.data?.requiresSav)) {
    return content?.data?.requiresSav;
  }
  return false;
};
